import {  useEffect, useState } from 'react';
import css3 from '../Approvals/css/approval-table.module.css';
//../css/approval-table.module.css
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
import { useSettingModal } from '../../../hooks/Context';
import { ViewDetails } from './modal';
import {RouteResponse} from '../../../types/index';
import {FetchAllRoutes, reOrderFetchedData, filterRouteName} from '../../../hooks/FetchData'

interface OldApplicants {
    Id: number;
    IsNewApplicant: boolean;
    Name: string;
    PreviousEmail: string;
    PhoneNumber: string;
    ApplicationType: string;
    Status: string;
  }
  


export const DATA_PER_PAGE = 10;

const OldApplicantTable = (props:any) =>{
    const [activeData,setActiveData] = useState<any>([]);
    const [pageData,setPageData] = useState<any>([]);
    const [currentPage,setCurrentPage] = useState<number>(0);
    const [pageArr,setPageArr] = useState<any>([]);
    const data:any = props.data;
    const [showIndex,setShowIndex] = useState<any>(null);
    const [showMore,setShowMore] = useState<boolean>(false);
    const {setShowModal,setShowCancel,setModalContent} = useSettingModal();
    // const showNYSC = props.nysc;

    const {data: allRoutesData} = FetchAllRoutes();
    const reOrderedAllRoutes = allRoutesData ? reOrderFetchedData((allRoutesData as RouteResponse )?.Data) : []
    
    const handleViewDetails = (details:any) =>{
        setShowCancel(true);
        setModalContent( <ViewDetails data={details} /> )
        setShowModal(true);
    }

    const handlePrevous = () =>{
        if(currentPage === 0){
            if(pageArr.length > 1){
                setCurrentPage(pageArr.at(-1))
                return false;
            }
            setCurrentPage(0);
            return false;
 
        }
        setCurrentPage(currentPage-1);
    }

    const handleNext = ()=>{
        if(pageArr.length > 1){
            if(currentPage === pageArr.at(-1)){
                setCurrentPage(0);
                return false;
            }
            setCurrentPage(currentPage+1);
            return false;
        }
        setCurrentPage(0);
        
    }
    const handleMore = (index:number) =>{
        if(index == showIndex){
            setShowIndex(null);
            setShowMore(false);
            return
        }
        setShowIndex(index);
        setShowMore(true);
    }
    
    
    useEffect(()=>{
        if(data && data.length > 0){
            setActiveData(data);
            let lastPage = Math.ceil(data.length/10);
            let i = 0;
            let arr = [];
            for(i = 0;i<lastPage;i++){
                arr.push(i);
            }
            setPageArr(arr);
            setPageData(data.slice(0,DATA_PER_PAGE))
        }
    },[data])



    useEffect(()=>{
        if(activeData && activeData.length > 0){    
                let start = currentPage*DATA_PER_PAGE;
                let stop = start+DATA_PER_PAGE;
                setPageData(data.slice(start,stop));  
        }
    },[currentPage])

    return (
        <div className={css3.container}>
            
            <>
                <div style={{gridTemplateColumns:`1.3fr 1.3fr 0.8fr  0.8fr`}}>
                    <div>Full Name</div>
                    <div>Email</div>
                    <div>Phone Number</div>
                    {/* <div>Routes</div> */}
                    <div>Status</div>
                </div>
                <div>
                    {pageData && pageData.length > 0 && pageData.map((eData:OldApplicants,index:number):any =>
                        <div key={index} style={{gridTemplateColumns:`1.3fr 1.3fr 0.8fr  0.8fr`}}>
                                <div>{eData.Name}</div>
                                <div>{eData.PreviousEmail?eData.PreviousEmail:'N/A'}</div>
                                <div>{eData.PhoneNumber}</div>
                                {/* <div>{filterRouteName(Number(eData.ApplicationType), reOrderedAllRoutes)}</div> */}
                                <div>
                                    {eData?.Status || 'Pending'}
                                    <span  className={css3.moreSpan}><MoreIcon /></span>
                                    <span  className={`${css3.moreSpan} ${index == showIndex?`${css3.activeMore}`:''} `} onClick={()=>handleMore(index)}><MoreIcon />
                                        {index == showIndex && showMore ?<div>
                                            <div onClick={()=>handleViewDetails(eData)}>View/Treat</div>
                                            {/* <div onClick={()=>handleApproveOrDecline(eData)}>Decline | Approve</div> */}
                                        </div>:''}
                                    </span>
                                </div>
                        </div>
                    )}
                </div>
                <div className={css3.pagination}>
                    <div>
                        <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous}><LBtn/></button>
                        {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                            if(index <= 2 && currentPage <= 2) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == currentPage ) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == pageArr.length-1) return (
                            <>
                                <>...</>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                            </>
                            )  

                            if(index == 0 ) return (
                            <>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                                <>...</>
                            </>)  

                            })} 
                        <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
                    </div>
                </div>
            </>
            
        </div>
    )
}

export default OldApplicantTable;